import React from "react";
import Select from 'react-select'
import './fieldSelect.css'

export default class FieldSelect extends React.Component {

    constructor(props) {
        super(props);
        this.ref = React.createRef()
    }

    onChange( v ) {
        this.props.container.changeParams( {[this.props.field]: v.value} )
    }

    render() {
        const p = this.props
        const {devis,showValidate,focusError} = p.container
        const value = devis.params[p.field]

        let message = devis.validateMessage(p.field)
        if ( p.onValidate ) {
            message = p.onValidate(value)
        }
        if ( message && !p.noCheck ) focusError(this.ref)
        if ( !showValidate ) message = undefined

        const label = p.label || devis.getLabel( p.field )
        let options = []
        let valueToLabel = {}
        if ( p.options ) {
            options = p.options
            for ( const opt of options ) {
                valueToLabel[opt.value] = opt.label
            }
        } else {
            valueToLabel = devis.getValueToLabel(p.field)
            for ( const v in valueToLabel ) {
                options.push( {value:v,label:valueToLabel[v]} )
            }
            options.sort((a,b)=>a.value>b.value?+1:-1)
        }
        let className = message?'front_form_row invalidbox':'front_form_row'
        return <><h3>{label}</h3>
            <div ref={this.ref} className={className}>
            <Select placeholder="Sélectionnez" 
                value = { {value:value,label:valueToLabel[value]} }
                options = { options }
                classNames = { FieldSelect.selectClassNames }
                onChange = { this.onChange.bind(this) }
                translate = "no"
                menuPortalTarget={document.body} 
                styles={{ menuPortal: base => ({ ...base, zIndex: 20 }) }}
            />
            </div>
            {message?<div className="invalid">{message}</div>:''}
        </>
    }
}

FieldSelect.selectClassNames = {
    'control': (_state) => 'choices__inner',
    'container': (_state) => 'choices',
    'menu': (_state) => 'choices__list',
    'menu-list': (_state) => 'menu-list',
    'option': (_state) => 'menu-list-option',
    'indicatorSeparator': (_state)=>'indicatorSeparator',
    'multiValue':(_state)=>'multiValue',
    'singleValue':(_state)=>'singleValue'
}

FieldSelect.listToOptions = (list,addEmpty=false) => 
    ( addEmpty ? ['',...list] : list ).map( item => ({label:item?item:'-',value:item}) )

